<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="point-terms-of-service">
      <Title jpn="Coin Terms of Use" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">These Terms of Use (hereinafter referred to as the ''Coin Terms of Use'') set forth the conditions for using ''Coin'' (defined below) on
              <a href="https://dorima-gtchax.com/" target="_blank" >https://dorima-gtchax.com/</a>
              (hereinafter referred to as the ''Service'') provided by Hatchi Co., Ltd. (hereinafter referred to as the ''Company'').</span>
            <span class="text">Please carefully read the Coin Terms of Use before considering purchasing Coin.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 1 - Definition of terms</span>
            <span class="text">The meanings of the terms in the following items in these Terms shall be as specified in each item.</span>
            <span class="text">(1) “Service Usage Agreement” means a contract regarding the use of the Service.</span>
            <span class="text">(2) “Service user” means a person who has concluded a service usage contract with our company.</span>
            <span class="text">(3) "Account Information" means information related to the Service User that the Service User has registered with the Service.</span>
            <span class="text">(4) "Coin" means a currency that can only be used by our company.</span>
            <span class="text">(5) "Used balance" is the balance of Coins held and available for use by the service user.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 2 - Coin</span>
            <span class="text">(1) Service users may purchase Coins that can be used within the Service using the method specified by the Company and at the price indicated by the Company within the Service. In addition, the Company may set purchase units, payment methods, usage periods, and other purchase conditions for the purchase of Coins for service users, and the set purchase conditions and payable amount, etc. will be posted within the Service or the services operated by the Company.</span>
            <span class="text">(2) When a service user expresses his or her intention to purchase a Coin using the method prescribed by the Company, a contract between the Service User and the Company regarding the purchase of the Coin shall be established, and the total amount for the purchase shall be determined.</span>
            <span class="text">(3) If the service user purchasing Coin is a minor, the service user must obtain consent from a parent or guardian before purchasing Coin.</span>
            <span class="text">(4) If a minor purchases a Coin, the Company will assume that the person with parental authority has consented to the purchase of the Coin.</span>
            <span class="text">(5) The service user's usage balance displayed within the Service will be linked to account information and recorded in the telecommunications equipment used to provide the Service and other services operated by the Company.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 3 - Use of Coin</span>
            <span class="text">(1)Coin can be used to purchase our products.</span>
            <span class="text">(2) Service users can acquire products provided by the Company within the amount of their Coin balance.</span>
            <span class="text">(3) If a service user uses Coin to purchase a product from the Company, the price of the product will be deducted from the Coin balance and the amount will be deemed to have been paid.</span>
            <span class="text">Unless otherwise specified, Coins granted free of charge by the Company to service users within the Service will be consumed preferentially.</span>
            <span class="text">(4) Service users can check their Coin balance within the Service. In addition, service users are responsible for managing and checking the increase and decrease of Coins.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 4 - Handling of Coin</span>
            <span class="text">(1) The Company will grant Coins to the User in accordance with the method determined by the Company when the User purchases Coins in the Service, when the Company conducts a campaign, or in other cases. The Coin purchase unit, price, validity period, and other conditions for granting Coins will be determined by the Company and displayed on the Service.</span>
            <span class="text">(2) The validity period of the Coin is 6 months from the date the Coin is granted.</span>
            <span class="text">(3) The Company will not refund any Coins acquired by the User, unless required by law. In the case of refunding Coins based on laws and regulations, the refund method and conditions will be posted separately in a manner determined by the Company.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 5 - Prohibition of cash conversion, etc.</span>
            <span class="text">Regarding all content acquired within this service, any transfer, transfer, lending, borrowing, etc. in the form of giving or receiving money or other real-world consideration (including, but not limited to, so-called RMT [real money trade]), whether directly, through third party intermediation, Internet auction, or other means, is prohibited.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 6 - Transfer of Coin, etc.</span>
            <span class="text">Service users may not assign, lend, gift, or otherwise transfer Coins or products to a third party, nor may they pledge or otherwise set a security interest.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 7 - Suspension of Coin purchase and use, etc.</span>
            <span class="text">If a Service User falls under any of the following, the Company may take measures against the Service User that the Company deems appropriate (including, but not limited to, suspending the purchase or use of Coin).</span>
            <span class="text">(1) If Coins or products are obtained or used by illegal means</span>
            <span class="text">(2) If the service user violates these Terms of Use</span>
            <span class="text">(3) In other cases where the Company determines that the Service User's use of the Service is inappropriate.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Established February 28, 2025</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n_point_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.point-terms-of-service{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .point-terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
